import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ba789bfa&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ba789bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba789bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba789bfa')) {
      api.createRecord('ba789bfa', component.options)
    } else {
      api.reload('ba789bfa', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ba789bfa&scoped=true&", function () {
      api.rerender('ba789bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-266f0a6sxG7Ze/JS/comp/CookieBox.vue"
export default component.exports